<template>
  <v-row>
    <v-col cols="2" class="flex-shrink-1">
      <img
        src="../../public/img/icons/icon-120x120.png"
        alt="MSA"
        style="max-height: 100px; height: auto; width: auto;"
      />
    </v-col>
    <v-col cols="7" class="flex-grow-1">
      <h5 class="text-h5">
        {{ contactInformation.mlaName }}
      </h5>
      <p class="font-weight-bold">
        {{ contactInformation.mlaBusinessName }} ABN - {{ contactInformation.mlaAbn }}
      </p>
      <hr />
      <v-row>
        <v-col cols="6">
          <div>A&colon; {{ contactInformation.msaPostalAddress }}</div>
          <div>E&colon; {{ contactInformation.msaEmailAddress }}</div>
          <div>W&colon; {{ contactInformation.msaWebsite }}</div>
        </v-col>
        <v-col cols="6">
          <div>P&colon; {{ contactInformation.msaPhoneAlt }}</div>
          <div>P&colon; {{ contactInformation.msaPhone }}</div>
          <div>F&colon; {{ contactInformation.msaFax }}</div>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="3" class="flex-shrink-1">
      <img
      class="float-right"
        src="../../public/img/icons/logo_mla_t.png"
        alt="MLA"
        style="max-height: 100px; height: auto; width: auto;"
      />
    </v-col>
  </v-row>
</template>

<script>
import { contactInformation } from '../utilities/env.js'

export default {
  name: 'ReportHeader',

  data: () => ({
    contactInformation
  })
}
</script>
